import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import ForClinics from "@/pages/ForClinics";
import ForPartners from "@/pages/ForPartners";
import ComplianceAccess from "@/pages/ComplianceAccess";
import TalkToAvA from "@/pages/TalkToAvA";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";
import AdminVendors from "@/pages/admin/AdminVendors";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminWebhooks from "@/pages/admin/AdminWebhooks";
import AdminMetrics from "@/pages/admin/AdminMetrics";
import AdminSessions from "@/pages/admin/AdminSessions";
import AdminTeam from "@/pages/admin/AdminTeam";

import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/for-clinics" element={<ForClinics />} />
          <Route path="/for-partners" element={<ForPartners />} />
          <Route path="/compliance" element={<ComplianceAccess />} />
          <Route path="/talk-to-ava" element={<TalkToAvA />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/leads/:id" element={<ProtectedRoute><AdminLeadDetail /></ProtectedRoute>} />
          <Route path="/admin/vendors" element={<ProtectedRoute><AdminVendors /></ProtectedRoute>} />
          <Route path="/admin/templates" element={<ProtectedRoute><AdminEmailTemplates /></ProtectedRoute>} />
          <Route path="/admin/webhooks" element={<ProtectedRoute><AdminWebhooks /></ProtectedRoute>} />
          <Route path="/admin/metrics" element={<ProtectedRoute><AdminMetrics /></ProtectedRoute>} />
          <Route path="/admin/sessions" element={<ProtectedRoute><AdminSessions /></ProtectedRoute>} />
          <Route path="/admin/team" element={<ProtectedRoute><AdminTeam /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
